import { useProBuilderSwitching } from '~/hooks/mutations/use-pro-builder';
import { switchAppBlockedReason } from './pro-builder-app-rules';
import { useProBuilderPublishStore } from './pro-builder-publish-store';

/**
 * FRONT-3077: the ONE busy reason every rebinding control reads — the header's
 * switcher, New and Save and the New view's Start. "Publishing" when `folder`
 * (the bound app) has a publish running, else "switching" while a bind is in
 * flight anywhere, else null. The decision itself is `switchAppBlockedReason`.
 */
export function useProBuilderBusyReason(folder: string | null | undefined): string | null {
  const publishing = useProBuilderPublishStore((s) => (folder ? s.running.includes(folder) : false));
  const switching = useProBuilderSwitching();
  return switchAppBlockedReason(publishing, switching);
}
